export const LOADER_FORMULARIO_COMPETENCIA_QUESTIONS          =       'LOADER_FORMULARIO_COMPETENCIA_QUESTIONS';
export const GET_FORMULARIO_COMPETENCIA_QUESTIONS             =       'GET_FORMULARIO_COMPETENCIA_QUESTIONS';
export const FORMULARIO_COMPETENCIA_QUESTIONS_FALLA           =       'FORMULARIO_COMPETENCIA_QUESTIONS_FALLA';
export const SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS     =       'SAVE_LOADER_FORMULARIO_COMPETENCIA_QUESTIONS';
export const FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL       =       'FORM_FORMULARIO_COMPETENCIA_QUESTIONS_FAIL';

